export default __webpack_public_path__ + "static/media/image-email-mobile.c8d60d54.png";